import { apiClient } from '@/lib/api';
import type {
  AuditEntityType,
  AuditTrailItem,
  AuditTrailResponse,
  AuditTrailSearchQuery,
  UserAuditSummary,
} from '@skewb-works/contracts';

const BASE = '/works-lite/audit-trail';

interface PaginationParams {
  limit?: number;
  skip?: number;
}

export async function getAuditTrailForEntity(
  entityType: AuditEntityType,
  entityId: number,
  params: PaginationParams = {},
): Promise<AuditTrailResponse> {
  const { limit = 50, skip = 0 } = params;
  return apiClient.get<AuditTrailResponse>(
    `${BASE}/entity/${entityType}/${entityId}?limit=${limit}&skip=${skip}`,
  );
}

export async function searchAuditTrail(
  filters: Partial<AuditTrailSearchQuery> = {},
): Promise<AuditTrailResponse> {
  const { limit = 50, skip = 0, ...rest } = filters;
  const params = new URLSearchParams();
  params.set('limit', String(limit));
  params.set('skip', String(skip));

  for (const [key, value] of Object.entries(rest)) {
    if (value !== undefined && value !== null) {
      params.set(key, String(value));
    }
  }

  return apiClient.get<AuditTrailResponse>(`${BASE}/search?${params.toString()}`);
}

export async function getUserAuditSummary(userId: number): Promise<UserAuditSummary> {
  return apiClient.get<UserAuditSummary>(`${BASE}/user/${userId}/summary`);
}

const EXPORT_PAGE_SIZE = 200;

export async function fetchAllAuditTrailMatching(
  filters: Partial<AuditTrailSearchQuery> = {},
): Promise<AuditTrailItem[]> {
  const baseFilters = { ...filters, limit: EXPORT_PAGE_SIZE, skip: 0 };
  const first = await searchAuditTrail(baseFilters);
  const collected: AuditTrailItem[] = [...first.data];

  while (collected.length < first.total) {
    const next = await searchAuditTrail({ ...baseFilters, skip: collected.length });
    if (next.data.length === 0) break;
    collected.push(...next.data);
  }

  return collected;
}
